var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.itemClasses},[_c('div',{class:_vm.beforeClass},[_vm._t("before")],2),_vm._v(" "),_c('div',{class:_vm.tailClasses}),_vm._v(" "),_c('div',{ref:"dot",class:_vm.headClasses,style:(_vm.customColor)},[_vm._t("dot")],2),_vm._v(" "),_c('div',{class:_vm.contentClasses},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/timeline/timeline-item.vue